import { Box, Button, Checkbox, Divider, FormControl, InputLabel, MenuItem, Select, Tab, Tabs, TextField, Typography } from "@mui/material";
import { CustomTabPanel } from "../../Components/CustomTabPanel";
import { CSSProperties, useRef, useState } from "react";
import FileUploadIcon from '@mui/icons-material/FileUpload';
import ContractProgressBar from "../../Components/Contract/progress";
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import ConfirmDialog from "../../Components/Dialogs/Confirm";
import DownloadModelButton from "../../Components/Buttons/DownloadModel";
import UploadFileButtonShort from "../../Components/Buttons/UploadFileShort";

const sharedTabsLayout: CSSProperties = {
    textWrap: 'nowrap',
    maxWidth: '650px',
    padding: '0px 10px 10px',
    justifyContent: 'flex-end'
}

const sharedHeadTable: CSSProperties = {
    textAlign: 'center',
    backgroundColor: 'var(--grey-light-transparent)',
    height: '55px'
}

const sharedRowTable: CSSProperties = {
    height: '70px'
}

const sharedTdTable: CSSProperties = {
    textAlign: 'center',
    textWrap: 'pretty'
}

const sharedDivider: CSSProperties = {
    height: '2px',
    backgroundColor: 'blue'
}

const column1w = '76%'
const column2w = '8%'
const column3w = '8%'
const column4w = '8%'

export default function ContractPage () {

    const [ selectedTab, setSelectedTab ] = useState(0)
    const [ openConfirm, setOpenConfirm ] = useState(false);
    const [ documentsApproved, setDocumentsAproved ] = useState<any>({})

    const [ selectedTabGarantia, setSelectedTabGarantia ] = useState(-1);
    const [ newTabGarantia, setNewTabGarantia ] = useState(-1)
    const inputRef = useRef<HTMLInputElement>(null)

    const handleChangeTab = (event: any, value: number): void => {
        setSelectedTab(value)
    }

    const handleChangeTabGarantia = (value: number): void => {
        if (selectedTabGarantia === -1) {
            setSelectedTabGarantia(value)
        } else {
            setNewTabGarantia(value)
            setOpenConfirm(true)
        }
    }

    const handleTabGarantiaConfirmCallback = () => {
        setSelectedTabGarantia(newTabGarantia)
    }

    const runDialogFile = () => {
        inputRef.current!.onchange = (e) => {
            console.log(inputRef.current!.files)
        }

        (inputRef.current as HTMLInputElement).click()
    }

    const loadStatusValidation = (variableName: string) => {
        return (
            <FormControl size="small" style={{ width: '160px', borderRadius: '6px', height: '36px' }}>
                <InputLabel id="label-select">Selecionar</InputLabel>
                <Select
                    labelId="label-select"
                    id="status-validacao"
                    value={documentsApproved[ variableName ]}
                    label="Selecionar"
                    onChange={(e) => setDocumentsAproved({ ...documentsApproved, [ variableName ]: e.target.value })}
                >
                    <MenuItem value={0}>Pendente</MenuItem>
                    <MenuItem value={1}>Aprovado</MenuItem>
                    <MenuItem value={2}>Negado</MenuItem>
                </Select>
            </FormControl>
        )
    }

    const loadDocumentButton = () => {
        return (
            <UploadFileButtonShort onClick={runDialogFile} />
        )
    }

    return (
        <div style={{ padding: '32px', background: 'var(--bg-light)' }}>
            <input ref={inputRef} hidden={true} type="file" accept=".docx, .pdf, .txt, .xml,application/msword" />
            <ConfirmDialog open={openConfirm} setOpen={setOpenConfirm} callback={handleTabGarantiaConfirmCallback} />
            <ContractProgressBar />
            <div style={{ padding: '16px' }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={selectedTab} onChange={handleChangeTab} aria-label="basic tabs example">
                        <Tab style={sharedTabsLayout} label="Documentação relativa às Pessoas Jurídicas" />
                        <Tab style={sharedTabsLayout} label="Documentação relativa ao tipo de garantia oferecida" />
                    </Tabs>
                </Box>

                {/* DOCUMENTAÇÃO RELATIVA ÀS PESSOAS JURÍDICAS */}
                <CustomTabPanel value={selectedTab} index={0}>
                    <table style={{ width: '100%', margin: '0px 0px 25px 0px' }}>
                        <tr style={sharedRowTable}>
                            <th style={{ ...sharedHeadTable, textAlign: 'left', paddingLeft: '15px', width: column1w }}>Documentação</th>
                            <th style={{ ...sharedHeadTable, width: column2w }}>Ações</th>
                            <th style={{ ...sharedHeadTable, width: column3w }}>Status de Validação</th>
                            <th style={{ ...sharedHeadTable, width: column4w }}>Notificar</th>
                        </tr>
                        <tr style={sharedRowTable}>
                            <td style={{ ...sharedTdTable, padding: '0px 0px 0px 30px', textAlign: 'left' }}>Estatuto/Contrato Social e alterações atualizados e devidamente registrados na Junta Comercial</td>
                            <td style={sharedTdTable}>{loadDocumentButton()}</td>
                            <td style={sharedTdTable}>{loadStatusValidation("contratoSocial")}</td>
                            <td style={sharedTdTable}>{<Checkbox style={{ height: '36px' }} />}</td>
                        </tr>
                        <tr style={sharedRowTable}>
                            <td style={{ ...sharedTdTable, padding: '0px 0px 0px 30px', textAlign: 'left' }}>Ato de designação dos atuais dirigentes</td>
                            <td style={sharedTdTable}>{loadDocumentButton()}</td>
                            <td style={sharedTdTable}>{loadStatusValidation("atuaisDirigentes")}</td>
                            <td style={sharedTdTable}>{<Checkbox style={{ height: '36px' }} />}</td>
                        </tr>
                        <tr style={sharedRowTable}>
                            <td style={{ ...sharedTdTable, padding: '0px 0px 0px 30px', textAlign: 'left' }}>Quadro indicando o total de processos (cíveis, fiscais/tributários e trabalhistas), os valores pedidos e os valores provisionados;</td>
                            <td style={sharedTdTable}>{loadDocumentButton()}</td>
                            <td style={sharedTdTable}>{loadStatusValidation("totalProcessos")}</td>
                            <td style={sharedTdTable}>{<Checkbox style={{ height: '36px' }} />}</td>
                        </tr>
                        <tr style={sharedRowTable}>
                            <td style={{ ...sharedTdTable, padding: '0px 0px 0px 30px', textAlign: 'left' }}>Certidão de Débitos Relativos a Créditos Tributários Federais e à Dívida Ativa da União</td>
                            <td style={sharedTdTable}>{loadDocumentButton()}</td>
                            <td style={sharedTdTable}>{loadStatusValidation("CertidaoDebritos")}</td>
                            <td style={sharedTdTable}>{<Checkbox style={{ height: '36px' }} />}</td>
                        </tr>
                        <tr style={sharedRowTable}>
                            <td style={{ ...sharedTdTable, padding: '0px 0px 0px 30px', textAlign: 'left' }}>Certificado de Regularidade do FGTS</td>
                            <td style={sharedTdTable}>{loadDocumentButton()}</td>
                            <td style={sharedTdTable}>{loadStatusValidation("certificadoRegularidade")}</td>
                            <td style={sharedTdTable}>{<Checkbox style={{ height: '36px' }} />}</td>
                        </tr>
                        <tr style={sharedRowTable}>
                            <td style={{ ...sharedTdTable, padding: '0px 0px 0px 30px', textAlign: 'left' }}>Certidão emitida pelo(s) Cartório(s) Distribuidor(es) da Justiça Estadual da Comarca da sede da pessoa jurídica em matéria cível, criminal e falimentar.</td>
                            <td style={sharedTdTable}>{loadDocumentButton()}</td>
                            <td style={sharedTdTable}>{loadStatusValidation("CertidaoEmitida")}</td>
                            <td style={sharedTdTable}>{<Checkbox style={{ height: '36px' }} />}</td>
                        </tr>
                        <tr style={sharedRowTable}>
                            <td style={{ ...sharedTdTable, padding: '0px 0px 0px 30px', textAlign: 'left' }}>Certidão do(s) Cartório(s) de Protestos ou Distribuidor de Protestos da Comarca da sede da Pessoa Jurídica;</td>
                            <td style={sharedTdTable}>{loadDocumentButton()}</td>
                            <td style={sharedTdTable}>{loadStatusValidation("CertidaoCartorio")}</td>
                            <td style={sharedTdTable}>{<Checkbox style={{ height: '36px' }} />}</td>
                        </tr>
                        <tr style={sharedRowTable}>
                            <td style={{ ...sharedTdTable, padding: '0px 0px 0px 30px', textAlign: 'left' }}>Recibo de entrega da Relação Anual de Informações Sociais – RAIS, ou Print de tela demonstrando a obrigatoriedade do eSocial.</td>
                            <td style={sharedTdTable}>{loadDocumentButton()}</td>
                            <td style={sharedTdTable}>{loadStatusValidation("RelacaoAnual")}</td>
                            <td style={sharedTdTable}>{<Checkbox style={{ height: '36px' }} />}</td>
                        </tr>
                    </table>
                    <Typography fontWeight={'bolder'}>Item possui um modelo que deve ser assinado e retornado</Typography>
                    <Divider style={sharedDivider} variant="fullWidth" />
                    <table style={{ width: '100%', marginTop: '10px' }}>
                        <tr style={sharedRowTable}>
                            <td style={{ ...sharedTdTable, padding: '0px 0px 0px 30px', textAlign: 'left', width: column1w }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    Declaração de Ações Coletivas
                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        <DownloadModelButton onClick={() => { }} />
                                    </div>
                                </div>
                            </td>
                            <td style={{ ...sharedTdTable, width: column2w }}>{loadDocumentButton()}</td>
                            <td style={{ ...sharedTdTable, width: column3w }}>{loadStatusValidation("AssinadoRetornado")}</td>
                            <td style={{ ...sharedTdTable, width: column4w }}>{<Checkbox style={{ height: '36px' }} />}</td>
                        </tr>
                    </table>
                    <Typography fontWeight={'bolder'}>Documentos opcionais</Typography>
                    <Divider style={sharedDivider} variant="fullWidth" />
                    <table style={{ width: '100%', marginTop: '10px' }}>
                        <tr style={sharedRowTable}>
                            <td style={{ ...sharedTdTable, padding: '0px 0px 0px 30px', textAlign: 'left', width: column1w }}>Licença Ambiental e outros documentos regulatórios pertinentes, como por exemplo Certificado de Qualidade em Biossegurança, de acordo com o cronograma do projeto (exceto de garantidor);</td>
                            <td style={{ ...sharedTdTable, width: column2w }}>{loadDocumentButton()}</td>
                            <td style={{ ...sharedTdTable, width: column3w }}>{loadStatusValidation("documentosRegulatorios")}</td>
                            <td style={{ ...sharedTdTable, width: column4w }}>{<Checkbox style={{ height: '36px' }} />}</td>
                        </tr>
                        <tr style={sharedRowTable}>
                            <td style={{ ...sharedTdTable, padding: '0px 0px 0px 30px', textAlign: 'left', width: column1w }}>Declaração de Licenciamento Ambiental, Licenciamento em Biossegurança e outras Autorizações e/ou Registros.</td>
                            <td style={{ ...sharedTdTable, width: column2w }}>{loadDocumentButton()}</td>
                            <td style={{ ...sharedTdTable, width: column3w }}>{loadStatusValidation("licenciamentoAmbiental")}</td>
                            <td style={{ ...sharedTdTable, width: column4w }}>{<Checkbox style={{ height: '36px' }} />}</td>
                        </tr>
                    </table>

                </CustomTabPanel>

                {/* DOCUMENTAÇÃO RELATIA AO TIPO DE GARANTIA OFERECIDA */}
                <CustomTabPanel value={selectedTab} index={1}>

                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', margin: '40px 0px' }}>
                        <Typography fontSize={16}>Qual o tipo de garantia a ser apresentada?</Typography>
                        <FormControl>
                            <InputLabel id="select-label">Garantia</InputLabel>
                            <Select
                                variant="outlined"
                                labelId="select-label"
                                id="simple-select"
                                value={selectedTabGarantia}
                                label="Selecionar Garantia"
                                onChange={(e) => handleChangeTabGarantia(e.target.value as number)}
                            >
                                <MenuItem value={1}>Fiança Bancária</MenuItem>
                                <MenuItem value={2}>Seguro Garantia</MenuItem>
                                <MenuItem value={3}>Garantia Imóveis</MenuItem>
                                <MenuItem value={4}>Outro...</MenuItem>
                            </Select>
                        </FormControl>
                    </div>

                    {/* FIANÇA BANCÁRIA */}
                    <CustomTabPanel value={selectedTabGarantia} index={1}>
                        <div>
                            <Typography style={{ fontWeight: '600', fontSize: '24px', color: 'blue', margin: '30px 0px' }}>Fiança Bancária</Typography>
                            <div>
                                <div>
                                    <Typography fontSize={18}>Indicação da instituição financeira que o prestará fiança</Typography>
                                    <TextField placeholder="Exemplos de datas requeridas" style={{ margin: '5px 0px', width: '800px' }} />
                                </div>
                                <div style={{ margin: '15px' }}>
                                    <Button style={{ marginBottom: '15px' }} variant="contained" startIcon={<CloudDownloadIcon />}>Download Modelo Conta Fiança</Button>

                                    <div onClick={runDialogFile} style={{ borderStyle: 'dashed', borderRadius: '15px', color: 'grey', height: '300px', borderWidth: '2px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', cursor: 'pointer' }}>
                                        <div style={{ display: 'flex' }}><FileUploadIcon style={{ fontSize: '40px', color: 'blue' }} /><Typography style={{ fontWeight: '600', fontSize: '15px', marginLeft: '5px', placeContent: 'center', color: 'blue' }}>Largue o arquivo aqui para upload (.docx, .pdf)</Typography></div>
                                        <Typography style={{ fontWeight: '600', fontSize: '15px', margin: '0px 0px 10px 0px', color: 'blue' }}>Ou</Typography>
                                        <Button style={{ color: 'blue' }} variant="outlined">Procure um arquivo no seu computador</Button>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </CustomTabPanel>

                    {/* SEGURO GARANTIA */}
                    <CustomTabPanel value={selectedTabGarantia} index={2}>
                        <div>
                            <Typography style={{ fontWeight: '600', fontSize: '24px', color: 'blue', margin: '30px 0px' }}>Seguro Garantia</Typography>
                            <div>
                                <div style={{ display: 'flex', margin: '0px 0px 15px 0px' }}>
                                    <Typography fontSize={18}>Indicação da seguradora que emitará a apólice de seguro garantia</Typography>
                                    <Button style={{ margin: '0px 0px 0px 12vw' }} variant="contained" startIcon={<CloudDownloadIcon />}>Download Modelo Apólice de Seguro</Button>
                                </div>
                                <div style={{ margin: '15px', display: 'flex', width: '100%', justifyContent: 'space-between' }}>

                                    <div style={{ width: '47%', borderStyle: 'dashed', borderRadius: '15px', color: 'grey', height: '200px', borderWidth: '2px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', cursor: 'pointer' }}>
                                        <div style={{ display: 'flex' }}><FileUploadIcon style={{ fontSize: '40px', color: 'blue' }} /><Typography style={{ fontWeight: '600', fontSize: '15px', marginLeft: '5px', placeContent: 'center', color: 'blue' }}>Largue o arquivo aqui para upload (.docx, .pdf)</Typography></div>
                                        <Typography style={{ fontWeight: '600', fontSize: '15px', margin: '0px 0px 10px 0px', color: 'blue' }}>Ou</Typography>
                                        <Button style={{ color: 'blue' }} variant="outlined">Procure um arquivo no seu computador</Button>
                                    </div>

                                    <div onClick={runDialogFile} style={{ width: '47%', borderStyle: 'dashed', borderRadius: '15px', color: 'grey', height: '200px', borderWidth: '2px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', cursor: 'pointer' }}>
                                        <div style={{ display: 'flex' }}><FileUploadIcon style={{ fontSize: '40px', color: 'blue' }} /><Typography style={{ fontWeight: '600', fontSize: '15px', marginLeft: '5px', placeContent: 'center', color: 'blue' }}>Largue o arquivo aqui para upload (.docx, .pdf)</Typography></div>
                                        <Typography style={{ fontWeight: '600', fontSize: '15px', margin: '0px 0px 10px 0px', color: 'blue' }}>Ou</Typography>
                                        <Button style={{ color: 'blue' }} variant="outlined">Procure um arquivo no seu computador</Button>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </CustomTabPanel>

                    {/* GARANTIA IMÓVEIS */}
                    <CustomTabPanel value={selectedTabGarantia} index={3}>
                        <div style={{ overflow: 'scroll' }}>
                            <Typography style={{ fontWeight: '600', fontSize: '24px', color: 'blue', margin: '30px 0px' }}>Garantia Imóveis</Typography>
                            <div>
                                <table style={{ width: '100%' }}>
                                    <tr style={sharedRowTable}>
                                        <td style={{ ...sharedTdTable, padding: '0px 0px 0px 30px', textAlign: 'left' }}>Certidão dos cartórios de registro de imóveis atualizada (RGI) dos imóveis apresentados em garantia e certidão de ônus reais e reipersecutória, se necessárioCertidão dos cartórios de registro de imóveis atualizada (RGI) dos imóveis apresentados em garantia e certidão de ônus reais e reipersecutória, se necessário</td>
                                        <td style={{ width: column2w, ...sharedTdTable }}>{loadDocumentButton()}</td>
                                        <td style={{ width: column3w, ...sharedTdTable }}>{loadStatusValidation("certidaoCatorio")}</td>
                                        <td style={{ width: column4w, ...sharedTdTable }}>{<Checkbox style={{ height: '36px' }} />}</td>
                                    </tr>
                                    <tr style={sharedRowTable}>
                                        <td style={{ ...sharedTdTable, padding: '0px 0px 0px 30px', textAlign: 'left' }}>Comprovação de Quitação Fiscal (IPTU/ITR)</td>
                                        <td style={{ width: column2w, ...sharedTdTable }}>{loadDocumentButton()}</td>
                                        <td style={{ width: column3w, ...sharedTdTable }}>{loadStatusValidation("comprovacaoQuitacaoFiscal")}</td>
                                        <td style={{ width: column4w, ...sharedTdTable }}>{<Checkbox style={{ height: '36px' }} />}</td>
                                    </tr>
                                    <tr style={sharedRowTable}>
                                        <td style={{ ...sharedTdTable, padding: '0px 0px 0px 30px', textAlign: 'left' }}>Se imóvel urbano: certidão municipal de uso e ocupação do solo, discriminando o regime, aproveitamento e ocupação do terreno, bem como eventuais alargamentos viários e/ou vias projetadas</td>
                                        <td style={{ width: column2w, ...sharedTdTable }}>{loadDocumentButton()}</td>
                                        <td style={{ width: column3w, ...sharedTdTable }}>{loadStatusValidation("certidaoMunicipal")}</td>
                                        <td style={{ width: column4w, ...sharedTdTable }}>{<Checkbox style={{ height: '36px' }} />}</td>
                                    </tr>
                                    <tr style={sharedRowTable}>
                                        <td style={{ ...sharedTdTable, padding: '0px 0px 0px 30px', textAlign: 'left' }}>Se imóvel rural: arquivo digital do google earth com perímetro da área oferecida, com a demarcação das áreas com restrições ambientais; comprovação de inscrição no cadastro de imóveis rurais do INCRA, cadastro ambiental rural - CAR </td>
                                        <td style={{ width: column2w, ...sharedTdTable }}>{loadDocumentButton()}</td>
                                        <td style={{ width: column3w, ...sharedTdTable }}>{loadStatusValidation("arquivoDigitalPerimetro")}</td>
                                        <td style={{ width: column4w, ...sharedTdTable }}>{<Checkbox style={{ height: '36px' }} />}</td>
                                    </tr>
                                    <tr style={sharedRowTable}>
                                        <td style={{ ...sharedTdTable, padding: '0px 0px 0px 30px', textAlign: 'left' }}>Laudo de Avaliação do bem, elaborado conforme “REQUISITOS - LAUDOS DE AVALIAÇÃO”</td>
                                        <td style={{ width: column2w, ...sharedTdTable }}>{loadDocumentButton()}</td>
                                        <td style={{ width: column3w, ...sharedTdTable }}>{loadStatusValidation("avaliacaoDoBem")}</td>
                                        <td style={{ width: column4w, ...sharedTdTable }}>{<Checkbox style={{ height: '36px' }} />}</td>
                                    </tr>
                                    <tr style={sharedRowTable}>
                                        <td style={{ ...sharedTdTable, padding: '0px 0px 0px 30px', textAlign: 'left' }}>Planta de implantação do imóvel com a posição de cada edificação, com quadro de áreas discriminado por benfeitoría e os limites das matriculas.</td>
                                        <td style={{ width: column2w, ...sharedTdTable }}>{loadDocumentButton()}</td>
                                        <td style={{ width: column3w, ...sharedTdTable }}>{loadStatusValidation("implantacaoImovel")}</td>
                                        <td style={{ width: column4w, ...sharedTdTable }}>{<Checkbox style={{ height: '36px' }} />}</td>
                                    </tr>
                                </table>

                                <Typography fontWeight={'bolder'}>Item possui um modelo que deve ser assinado e retornado</Typography>
                                <Divider style={sharedDivider} variant="fullWidth" />

                                <table style={{ width: '100%', marginTop: '10px' }}>
                                    <tr style={sharedRowTable}>
                                        <td style={{ ...sharedTdTable, padding: '0px 0px 0px 30px', textAlign: 'left' }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                Declaração de Ações Coletivas
                                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                    <DownloadModelButton onClick={() => { }} />
                                                </div>
                                            </div>
                                        </td>
                                        <td style={{ width: column2w, ...sharedTdTable }}>{loadDocumentButton()}</td>
                                        <td style={{ width: column3w, ...sharedTdTable }}>{loadStatusValidation("NecessitaAssinadoRetornado")}</td>
                                        <td style={{ width: column4w, ...sharedTdTable }}>{<Checkbox style={{ height: '36px' }} />}</td>
                                    </tr>
                                </table>

                                <Typography fontWeight={'bolder'}>Documentos opcionais</Typography>
                                <Divider style={sharedDivider} variant="fullWidth" />

                                <table style={{ width: '100%', marginTop: '10px' }}>
                                    <tr style={sharedRowTable}>
                                        <td style={{ ...sharedTdTable, padding: '0px 0px 0px 30px', textAlign: 'left' }}>Licença Ambiental e outros documentos regulatórios pertinentes, como por exemplo Certificado de Qualidade em Biossegurança, de acordo com o cronograma do projeto (exceto de garantidor);</td>
                                        <td style={{ width: column2w, ...sharedTdTable }}>{loadDocumentButton()}</td>
                                        <td style={{ width: column3w, ...sharedTdTable }}>{loadStatusValidation("licencaAmbientalOutros")}</td>
                                        <td style={{ width: column4w, ...sharedTdTable }}>{<Checkbox style={{ height: '36px' }} />}</td>
                                    </tr>
                                    <tr style={sharedRowTable}>
                                        <td style={{ ...sharedTdTable, padding: '0px 0px 0px 30px', textAlign: 'left' }}>Declaração de Licenciamento Ambiental, Licenciamento em Biossegurança e outras Autorizações e/ou Registros.</td>
                                        <td style={{ width: column2w, ...sharedTdTable }}>{loadDocumentButton()}</td>
                                        <td style={{ width: column3w, ...sharedTdTable }}>{loadStatusValidation("licencaAmbientalAutorizacoes")}</td>
                                        <td style={{ width: column4w, ...sharedTdTable }}>{<Checkbox style={{ height: '36px' }} />}</td>
                                    </tr>
                                </table>

                            </div>
                        </div>
                    </CustomTabPanel>

                    {/* OUTROS */}
                    <CustomTabPanel value={selectedTabGarantia} index={4}>

                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginBottom: '15px' }}>
                            <div style={{ width: '68%' }}>
                                <Typography fontSize={18}>Ato de designação dos atuais dirigentes*</Typography>
                                <TextField placeholder="Exemplos de datas requeridas" style={{ width: '100%' }} />
                            </div>
                            <div style={{ width: '15%' }}>
                                {
                                    loadDocumentButton()
                                }
                            </div>
                            <Button style={{ width: '15%' }} variant="contained">Salvar</Button>
                        </div>

                        <table style={{ width: '100%' }}>
                            <tr>
                                <th style={{ ...sharedHeadTable, textAlign: 'left', paddingLeft: '15px', width: column1w }}>Documentação</th>
                                <th style={{ ...sharedHeadTable, width: column2w }}>Ações</th>
                                <th style={{ ...sharedHeadTable, width: column3w }}>Status de Validação</th>
                                <th style={{ ...sharedHeadTable, width: column4w }}>Notificar</th>
                            </tr>
                            <tr style={sharedRowTable}>
                                <td style={{ ...sharedTdTable, padding: '0px 0px 0px 30px', textAlign: 'left' }}>Descrição de exemplos preenchidos pelo usuário</td>
                                <td style={sharedTdTable}>{loadDocumentButton()}</td>
                                <td style={sharedTdTable}>{loadStatusValidation("DadosDescricao")}</td>
                                <td style={sharedTdTable}>{<Checkbox style={{ height: '36px' }} />}</td>
                            </tr>
                        </table>


                    </CustomTabPanel>

                </CustomTabPanel>
            </div>
        </div>
    )
}